/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import Select from 'components/select';
import ProvisioningStyles from 'pages/provisioning/day2-operation-paas/style';
import { sspSubmitOrder } from 'pages/provisioning/store/day2-operation-paas';

const Tier = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [options, setOptions] = React.useState([]);
    const setTier = (tier, tierDetail) => {
        setOrder({ ...order, tier, tierDetail });
    };
    const tierApi = useMutation(() => axios.get(`${endPoints.ssp.day2OperationPass.tier}`));
    const seldValueExistsInOptions = (tierValue) => options.find((option) => tierValue === option?.value);
    const handleOnSelectChange = (selected) => {
        if (seldValueExistsInOptions(selected?.value)) {
            setTier(selected?.value, selected?.data);
        }
    };
    React.useEffect(() => {
        if (tierApi?.isSuccess) {
            if (tierApi?.data?.data) setOptions(tierApi?.data?.data?.map((app) => ({ label: app.name, value: app.name, data: app })));
        }
    }, [tierApi?.isSuccess]);

    React.useEffect(() => {
        tierApi.mutate();
    }, []);
    React.useEffect(() => {
        if (!order?.tier && order?.isTouched) setIsTouched(true);
    }, [order?.tier, order?.isTouched]);

    return (
        <Box sx={ProvisioningStyles.box}>
            <Select
                key="tier"
                label="Tier *"
                value={order?.tier || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                disabled={tierApi.isLoading}
                isLoading={tierApi.isLoading}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(Tier);
